<template>
  <!-- Table Container Card -->
  <b-card
    no-body
    class="mb-0"
  >
    <report-add-new
      @fetch-areas-for-report="fetchAreasForReport"
      @create-reports="createReports"
    />
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            v-b-modal.create-report-modal
            variant="primary"
            style="margin-right: 20px"
          >
            {{ this.$t('create_reports') }}
          </b-button>
        </b-col>
      </b-row>
    </div>

    <b-table
      ref="refReportListTable"
      responsive
      :fields="tableColumns"
      :items="fetchReports"
      show-empty
      :empty-text="$t('no_matching_records')"
      class="position-relative"
    >
      <!-- Column: Area Name -->
      <template #cell(areaName)="data">
        <span
          class="font-weight-bold"
          style="text-transform: capitalize"
        >
          {{ data.value }}
        </span>
      </template>

      <!-- Column: Total Shifts -->
      <template #cell(totalShifts)="data">
        <span
          class="font-weight-bold"
          style="text-align: center"
        >
          <div
            class="text-center"
            style="max-width: 100px"
          >
            {{ data.value }}
          </div>
        </span>
      </template>

      <!-- Column: Status -->
      <template #cell(status)="data">
        <span
          class="font-weight-bold"
          style="text-transform: capitalize; text-align: center"
        >
          {{ data.value }}
        </span>
      </template>

      <!-- Column: Start -->
      <template #cell(start)="data">
        <span
          class="font-weight-bold"
        >
          {{ (new Date(data.value)).toLocaleDateString('fi', {day: '2-digit', month: '2-digit', year: '2-digit'}) }}
        </span>
      </template>

      <!-- Column: End -->
      <template #cell(end)="data">
        <span
          class="font-weight-bold"
        >
          {{ (new Date(data.value)).toLocaleDateString('fi', {day: '2-digit', month: '2-digit', year: '2-digit'}) }}
        </span>
      </template>

      <!-- Column: Created By -->
      <template #cell(createdBy)="data">
        <span
          class="font-weight-bold"
          style="text-transform: capitalize"
        >
          {{ data.value }}
        </span>
      </template>

      <!-- Column: Created -->
      <template #cell(created)="data">
        <span
          class="font-weight-bold"
          style="text-transform: capitalize"
        >
          {{ data.value.toDate().toLocaleString('fi', {day: '2-digit', month: '2-digit', year: '2-digit',hour: '2-digit', minute:'2-digit'}) }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.hwUiLayout.isRTL"
        >

          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>

          <b-dropdown-item
            v-if="data.item.downloadURLS"
            :href="data.item.downloadURLS.csv"
          >
            <feather-icon icon="DownloadCloudIcon" />
            <span class="align-middle ml-50">Download</span>
          </b-dropdown-item>

          <b-dropdown-item
            v-b-modal.modal-danger
            @click="onDeleteReport(data.item.id)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">{{ $t('delete') }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <b-modal
      id="modal-danger"
      ok-only
      ok-variant="danger"
      :ok-title="$t('delete')"
      modal-class="modal-danger"
      centered
      :title="$t('reports.delete_modal.title')"
      @ok="confirmDelete"
    >
      <b-card-text class="mt-2">
        {{ $t('reports.delete_modal.warningMessage') }}
      </b-card-text>

    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable,
  BDropdown, BDropdownItem,
  BCardText, BModal,
} from 'bootstrap-vue'
import ReportAddNew from './ReportAddNew.vue'
import useReportList from './useReportList'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BCardText,
    BModal,
    ReportAddNew,
  },
  setup() {
    const {
      createReports,
      fetchAreasForReport,
      tableColumns,
      fetchReports,
      refReportListTable,
      confirmDelete,
      onDeleteReport,
    } = useReportList()

    return {
      createReports,
      fetchAreasForReport,
      tableColumns,
      fetchReports,
      refReportListTable,
      confirmDelete,
      onDeleteReport,
    }
  },
}
</script>
